export enum KnmReasonTypeCodesEnum {
  RSN_PP_I = 'RSN_PP_I',
  RSN_PP_II = 'RSN_PP_II',
  RSN_PP_III = 'RSN_PP_III',
  RSN_PP_IV = 'RSN_PP_IV',
  RSN_PP_OTHER = 'RSN_PP_OTHER',
}
